import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-privacy-notice',
  imports: [],
  templateUrl: './privacy-notice.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './privacy-notice.scss',
})
export class PrivacyNotice {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Privacy Notice';
  protected readonly seoDescription =
    'Read the AE EventsCo, LLC and Affiliates Engagement Privacy Notice, including how personal information is collected, used, shared, retained, and protected.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy Notice', path: '/privacy-notice' },
      ],
    });
  }
}
